var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardiometabolicos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1509",
    "data-name": "Grupo 1509",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51.588,
    height: 46.326,
    viewBox: "0 0 51.588 46.326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_146",
    "data-name": "Rect\\xE1ngulo 146",
    width: 51.588,
    height: 46.326,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1508",
    "data-name": "Grupo 1508",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_437",
    "data-name": "Trazado 437",
    d: "M0,14a24.121,24.121,0,0,1,.6-2.842C2.669,4.961,6.9,1.156,13.389.154c4.1-.633,7.741.745,10.969,3.268.5.391.972.816,1.414,1.189a30.2,30.2,0,0,1,2.613-2.08C33.577-.761,38.9-.658,44.159,2.272a13.693,13.693,0,0,1,7.235,10.34,14.6,14.6,0,0,1-4.105,12.935c-4.4,4.5-8.889,8.915-13.34,13.366q-3.347,3.348-6.695,6.694a1.768,1.768,0,0,1-2.837.012Q14.535,35.739,4.663,25.848a15.3,15.3,0,0,1-4.581-9.3A1.069,1.069,0,0,0,0,16.32V14M25.713,42.268c.265-.253.388-.366.506-.483Q35.406,32.6,44.591,23.409a11.289,11.289,0,0,0,3.367-10.281A11.371,11.371,0,0,0,35.112,3.682,11.985,11.985,0,0,0,27.2,8.136a1.7,1.7,0,0,1-2.642.134c-.5-.477-.981-.965-1.471-1.448A11.518,11.518,0,0,0,5.4,21.381a20.551,20.551,0,0,0,3.16,3.565Q17,33.313,25.383,41.738a2.778,2.778,0,0,1,.329.529",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_438",
    "data-name": "Trazado 438",
    d: "M92.319,89.4c1.1-1.824,2.179-3.564,3.208-5.332a2.119,2.119,0,0,1,2.059-1.156c1.393.033,2.787,0,4.181.013a1.722,1.722,0,0,1,1.767,1.419,1.668,1.668,0,0,1-.936,1.831,2.5,2.5,0,0,1-.926.177c-.94.022-1.882.043-2.82-.006a1.025,1.025,0,0,0-1.058.614c-1.3,2.2-2.625,4.372-3.951,6.55a1.634,1.634,0,0,1-2.132.818,2.647,2.647,0,0,1-1.025-.975c-2.562-4.233-5.094-8.485-7.634-12.732-.093-.155-.191-.308-.328-.528-.119.2-.212.35-.294.5-.947,1.795-1.9,3.584-2.831,5.389a1.944,1.944,0,0,1-1.935,1.162c-1.595-.03-3.19,0-4.785-.01a1.72,1.72,0,1,1,0-3.43c1.192-.006,2.385-.018,3.576.008a.657.657,0,0,0,.685-.429c1.27-2.439,2.564-4.866,3.834-7.305a1.8,1.8,0,0,1,1.58-1.141A1.821,1.821,0,0,1,84.241,75.9q3.86,6.487,7.743,12.96c.093.156.192.308.334.534",
    transform: "translate(-61.463 -64.766)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardiometabolicos);
export default __webpack_public_path__ + "static/media/cardiometabolicos.3d6c8135b7be9c2039ce4ef0e44e0f59.svg";
export { ForwardRef as ReactComponent };